import React from 'react';
import { Flex } from 'pounceV2';
import PageHeaderV3, { PAGE_HEADER_ACTIONS_PORTAL_ID } from 'Components/PageHeader/PageHeaderV3';
import { usePageHeaderContextV3 } from 'Source/contexts/pageHeaderContext';
import { useGetPageHasHeader } from 'Components/Header/utils';
import { useTheme } from '@mui/material';

const HeaderV3 = () => {
  const theme = useTheme();
  const { tokens } = theme.palette;
  const { isSticky, headerStyles } = usePageHeaderContextV3();
  const hasHeader = useGetPageHasHeader();

  if (!hasHeader) {
    return null;
  }

  return (
    <Flex
      id={PAGE_HEADER_ACTIONS_PORTAL_ID}
      as="header"
      align="center"
      justify="space-between"
      py={6}
      data-testid="main-header"
      left={isSticky ? 0 : undefined}
      top={isSticky ? 0 : undefined}
      position={isSticky ? 'sticky' : undefined}
      backgroundColor={isSticky ? tokens.background.accent[1][4] : undefined}
      zIndex={isSticky ? 5 : undefined}
      {...headerStyles}
    >
      <PageHeaderV3 />
    </Flex>
  );
};

export default HeaderV3;
